"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlainTextHeaderFormatter = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
function PlainTextCell(props) {
    const text = props.col.headerText;
    return react_1.default.createElement("span", { title: text }, text);
}
function PlainTextHeaderFormatter() {
    return function DataGridHeaderCell(props) {
        return (react_1.default.createElement("div", { style: { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontWeight: 500 } },
            react_1.default.createElement(PlainTextCell, Object.assign({}, props))));
    };
}
exports.PlainTextHeaderFormatter = PlainTextHeaderFormatter;
//# sourceMappingURL=PlainTextHeader.js.map